import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { UnsubscribeComponent } from './pages/unsubscribe/unsubscribe.component';
import { adminGuard } from './auth/admin.guard';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  {
    path: 'events',
    loadComponent: () =>
      import('./pages/events/events.component').then(m => m.EventsComponent)
  },
  {
    path: 'newsletter',
    loadComponent: () =>
      import('./pages/newsletter/newsletter.component').then(m => m.NewsletterComponent)
  },
  {
    path: 'community-news',
    loadComponent: () =>
      import('./pages/community-news/community-news.component').then(m => m.CommunityNewsComponent)
  },
  {
    path: 'playlists',
    loadComponent: () =>
      import('./pages/playlists/playlists.component').then(m => m.PlaylistsComponent)
  },
  { path: 'unsubscribe', component: UnsubscribeComponent },
  {
    path: 'event/:eventId',
    loadComponent: () =>
      import('./pages/event-detail/event-detail.component').then(m => m.EventDetailComponent)
  },
  {
    path: 'admin/login',
    loadComponent: () =>
      import('./pages/admin-login/admin-login.component').then(m => m.AdminLoginComponent),
    data: { preload: false }
  },
  {
    path: 'admin/dashboard',
    loadComponent: () =>
      import('./pages/admin-dashboard/admin-dashboard.component').then(m => m.AdminDashboardComponent),
    canActivate: [adminGuard],
    data: { preload: false }
  },
  { path: '**', redirectTo: '' }
];
